import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["slide", "progress", "share"];
  static values = {
    index: { type: Number, default: 0 },
    shareUrl: String,
    copiedText: String,
  };

  connect() {
    this.boundHandleOpen = this.handleOpen.bind(this);
    document.addEventListener("click", this.boundHandleOpen);
  }

  disconnect() {
    document.removeEventListener("click", this.boundHandleOpen);
  }

  handleOpen(event) {
    if (!event.target.closest("[data-rewind-open]")) return;
    event.preventDefault();
    WGModal.open("#rewind-overlay");
  }

  next() {
    this.indexValue = Math.min(this.indexValue + 1, this.slideTargets.length - 1);
  }

  previous() {
    this.indexValue = Math.max(this.indexValue - 1, 0);
  }

  share() {
    const url = this.shareUrlValue || window.location.href;

    // navigator.share is unavailable on many desktop browsers (e.g. Firefox),
    // so fall back to copying the link to the clipboard.
    if (navigator.share) {
      navigator.share({ title: document.title, text: this.currentShareText, url }).catch(() => {});
    } else {
      this.copyToClipboard(url);
    }
  }

  copyToClipboard(url) {
    if (!navigator.clipboard) return;

    navigator.clipboard.writeText(url).then(() => this.confirmCopied()).catch(() => {});
  }

  confirmCopied() {
    if (!this.hasShareTarget || !this.copiedTextValue) return;

    const label = this.shareTarget.querySelector(".rewind-share-label");
    if (!label) return;

    const original = label.textContent;
    label.textContent = this.copiedTextValue;
    setTimeout(() => {
      label.textContent = original;
    }, 2000);
  }

  indexValueChanged() {
    this.slideTargets.forEach((slide, i) => {
      const active = i === this.indexValue;
      slide.classList.toggle("active", active);
    });

    this.progressTargets.forEach((item, i) => {
      item.classList.toggle("active", i === this.indexValue);
    });
  }

  get currentShareText() {
    return this.slideTargets[this.indexValue]?.dataset.shareText ?? document.title;
  }
}
